import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d293419a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "FootmarkGoods home-module-bg"
}
const _hoisted_2 = { class: "FootmarkGoods-header" }
const _hoisted_3 = { class: "FootmarkGoods-header-title" }
const _hoisted_4 = { class: "FootmarkGoods-header-enter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-caret-right",
  style: {"margin-left":"6px"}
}, null, -1))
const _hoisted_6 = { class: "FootmarkGoods-list" }

import { reactive, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { useRouter } from 'vue-router'
import GoodsItem from '@/components/common/GoodsItem.vue'
import { getFavoriteGoodsList, getLookGoodsList, getBuyGoodsList } from '@/apis/goods'
import { bury } from '@/util/useBury'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  context: {
    type: Object,
    default: null
  }
},
  setup(__props) {

const props = __props
const stationCode = useSite2Station()

const router = useRouter()

onMounted(() => {
  getList()
})



const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 5
  }
})

// 获取列表
const getList = () => {
  if (props.context.type === 'look') {
    // 看过
    const formData = {
      pageNum: data.page.currentPage,
      pageSize: data.page.pageSize,
      stationCode
    }
    getLookGoodsList(formData).then((res: any) => {
      if (res.code === '0') {
        data.list = res.data.records.slice(0, 5)
      }
    })
  } else
  if (props.context.type === 'buy') {
    // 买过
    const formData = {
      pageNum: data.page.currentPage,
      pageSize: data.page.pageSize
    }
    getBuyGoodsList(formData).then((res: any) => {
      if (res.code === '0') {
        data.list = res.data.records.slice(0, 5)
      }
    })
  } else
  if (props.context.type === 'collect') {
    // 收藏
    const formData = {
      pageNum: data.page.currentPage,
      pageSize: data.page.pageSize
    }
    getFavoriteGoodsList(formData).then((res: any) => {
      if (res.code === '0') {
        data.list = res.data.records.slice(0, 5)
      }
    })
  }
}

// 商品取消收藏
const cancelCollect = (productCode: string) => {
  if (props.context.type === 'collect') {
    const index = data.list.findIndex((item: any) => item.productCode === productCode)
    data.list.splice(index, 1)
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_unref(data).list.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.context.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: props.context.routerPath,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(bury)({ look: 'MyChannel_Click_BuyGoodsMore', buy: 'MyChannel_Click_BuyGoodsMore', collect: 'MyChannel_Click_CollectGoodsMore' }[__props.context.type])))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "btn",
                  round: "",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('查看更多')) + " ", 1),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(data).list.length !== 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(data).list, (item) => {
                return (_openBlock(), _createBlock(GoodsItem, {
                  key: item.productCode,
                  item: item,
                  showChannel: 2,
                  onClick: ($event: any) => (_unref(bury)({ look: 'MyChannel_Click_SeenGoods', buy: 'MyChannel_Click_BuyGoods', collect: 'MyChannel_Click_CollectGoods' }[__props.context.type], item.productTitle, item.productCode)),
                  onCancelCollect: cancelCollect
                }, null, 8, ["item", "onClick"]))
              }), 128))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                class: "FootmarkGoods-list-empty",
                description: _unref(t)('没有更多了')
              }, null, 8, ["description"]))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})